import {
  Box,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { allCountries } from "country-telephone-data";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/Button";
import Loader from "../components/Loader";
import Title from "../components/PageTitle";
import { useToast } from "../components/Toast";
const AddDoctor = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const token = localStorage.getItem("token");
  const [Loading, isLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [doctorDetails, setDoctorDetails] = useState({
    name: "",
    mobile: "",
    validTill: "",
    username: "",
    password: "",
    countryCode: "",
    gender: "",
  });

  const [clinicDetails, setClinicDetails] = useState({
    clinicName: "",
    clinicCountryCode: "",
    clinicMobile: "",
    address: "",
    email: "",
    website: "",
    city: "",
    state: "",
    country: "",
    mapLink: "",
  });

  const [kioskDetails, setKioskDetails] = useState({
    kioskName: "",
    DWId: "",
    kioskLocation: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    validTill: "",
    username: "",
    password: "",
    clinicName: "",
    clinicMobile: "",
    address: "",
    kioskName: "",
    city: "",
    kioskLocation: "",
    countryCode: "",
    gender: "",
  });

  const [showCredentials, setShowCredentials] = useState(false); // State to control visibility of username and password fields

  const handleDoctorChange = (e) => {
    const { name, value } = e.target;
    setDoctorDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const handleClinicChange = (e) => {
    const { name, value } = e.target;
    setClinicDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const handleKioskChange = (e) => {
    const { name, value } = e.target;
    setKioskDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const handleCredSubmit = (e) => {
    e.preventDefault();

    setErrors({
      name: "",
      mobile: "",
      validTill: "",
      username: "",
      password: "",
      clinicName: "",
      clinicCountryCode: "",
      clinicMobile: "",
      address: "",
      kioskName: "",
      city: "",
      kioskLocation: "",
      countryCode: "",
      gender: "",
    });

    let valid = true;
    const newErrors = {};

    if (!doctorDetails.name) {
      newErrors.name = "Name is required";
      valid = false;
    }

    if (!doctorDetails.countryCode) {
      newErrors.countryCode = "country code is required";
      valid = false;
    }
    if (!doctorDetails.mobile) {
      newErrors.mobile = "Mobile is required";
      valid = false;
    }
    if (!doctorDetails.validTill) {
      newErrors.validTill = "Validity required";
      valid = false;
    }
    if (!doctorDetails.gender) {
      newErrors.gender = "Gender is required";
      valid = false;
    }
    if (!clinicDetails.city) {
      newErrors.city = "City is required";
      valid = false;
    }
    if (!clinicDetails.clinicCountryCode) {
      newErrors.clinicCountryCode = "Clinic CountryCode is required";
      valid = false;
    }
    if (!clinicDetails.clinicMobile) {
      newErrors.clinicMobile = "Clinic contact is required";
      valid = false;
    }

    if (!clinicDetails.clinicName) {
      newErrors.clinicName = "Clinic Name is required";
      valid = false;
    }
    if (!clinicDetails.address) {
      newErrors.address = "Address is required";
      valid = false;
    }

    if (!kioskDetails.kioskName) {
      newErrors.kioskName = "Kiosk Name is required";
      valid = false;
    }

    if (!kioskDetails.kioskLocation) {
      newErrors.kioskLocation = "Location is required";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    } else {
      setShowCredentials(true);
    }
  };
  const handleDateSelect = (event) => {
    const selectedDate = event.target.value;
    setDoctorDetails((prevState) => ({
      ...prevState,
      validTill: selectedDate,
    }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Allowed image file types
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

      // Check if the selected file is one of the allowed types
      if (allowedTypes.includes(file.type)) {
        setSelectedFile(file);
      } else {
        // If the file type is not valid, show an error message
        console.error(
          "Invalid file type. Please upload a PNG, JPG, or JPEG image.",
        );

        toast.error(
          "Invalid file type. Please upload a PNG, JPG, or JPEG image",
        );
      }
    }
  };

  const HandleSubmit = async (e) => {
    e.preventDefault();

    setErrors({
      username: "",
      password: "",
    });

    let valid = true;
    const newErrors = {};

    if (!doctorDetails.username) {
      newErrors.username = "Username is required";
      valid = false;
    }

    if (!doctorDetails.password) {
      newErrors.password = "Password is required";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    } else {
      try {
        const formData = new FormData();
        isLoading(true);
        formData.append(
          "doctor",
          JSON.stringify({
            name: doctorDetails.name,
            mobile: doctorDetails.mobile,
            countryCode: doctorDetails.countryCode,
            username: doctorDetails.username,
            password: doctorDetails.password,
            gender: doctorDetails.gender,
            validTill: doctorDetails.validTill,
            websiteUrl: clinicDetails.website,
          }),
        );
        formData.append(
          "clinic",
          JSON.stringify({
            name: clinicDetails.clinicName,
            countryCode: clinicDetails.clinicCountryCode,
            mobile: clinicDetails.clinicMobile,
            address: clinicDetails.address,
            email: clinicDetails.email,
            city: clinicDetails.city,
            state: clinicDetails.state,
            country: clinicDetails.country,
            mapsLink: clinicDetails.mapLink,
          }),
        );
        formData.append(
          "kiosk",
          JSON.stringify({
            name: kioskDetails.kioskName,
            location: kioskDetails.kioskLocation,
          }),
        );
        if (selectedFile && selectedFile instanceof File) {
          // Ensure that the file is either a PNG or JPG image
          if (
            selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg" ||
            selectedFile.type === "image/jpeg"
          ) {
            formData.append("clinic_logo", selectedFile);
          } else {
            console.error(
              "Invalid file type. Please upload a PNG or JPG image for logo.",
            );
            toast.error(
              "Invalid file type. Please upload a PNG, JPG, or JPEG image for logo",
            );
            isLoading(false);
            return;
          }
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_HOST_URL}/ops/v1/doctors/create`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        isLoading(false);
        navigate("/dashboard/doctor");
        toast.success("Doctor added successfully..!");
      } catch (error) {
        isLoading(false);
        console.error(
          "Error submitting data:",
          error.response ? error.response.data : error.message,
        );
        toast.error("An error occurred while submitting data!");
      }
    }
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Title text="Add Doctor" />

      <Paper sx={{ padding: 3 }}>
        <Box sx={{ marginBottom: 2 }}>
          <Typography variant="h6" gutterBottom>
            Doctor Details
          </Typography>

          <Grid container spacing={2} sx={{ marginBottom: 2 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                name="name"
                value={doctorDetails.name}
                onChange={handleDoctorChange}
                fullWidth
                error={!!errors.name}
                helperText={errors.name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                type="date"
                label="Valid Till"
                name="validTill"
                value={doctorDetails.validTill}
                onChange={handleDateSelect}
                variant="outlined"
                fullWidth
                error={!!errors.validTill}
                helperText={errors.validTill}
                InputLabelProps={{
                  shrink: true,
                }}
                style={{
                  marginBottom: "8px",
                }}
              />
            </Grid>

            <Grid item xs={12} sm={1}>
              <TextField
                select
                label="Country Code"
                name="countryCode"
                value={doctorDetails.countryCode}
                onChange={handleDoctorChange}
                fullWidth
                error={!!errors.countryCode}
                helperText={errors.countryCode}
              >
                {allCountries.map((country) => (
                  <MenuItem
                    key={country.dialCode + country.iso2}
                    value={`+${country.dialCode}`}
                  >
                    {country.name} (+{country.dialCode})
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                label="Mobile"
                name="mobile"
                value={doctorDetails.mobile}
                onChange={handleDoctorChange}
                fullWidth
                error={!!errors.mobile}
                helperText={errors.mobile}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                label="Gender"
                name="gender"
                value={doctorDetails.gender}
                onChange={handleDoctorChange}
                fullWidth
                error={!!errors.gender}
                helperText={errors.gender}
              >
                {[
                  { value: "male", label: "Male" },
                  { value: "female", label: "Female" },
                ].map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Box>


        <Box sx={{ marginBottom: 2 }}>
          <Typography variant="h6" gutterBottom>
            Clinic Details
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Clinic Name"
                name="clinicName"
                value={clinicDetails.clinicName}
                onChange={handleClinicChange}
                fullWidth
                error={!!errors.clinicName}
                helperText={errors.clinicName}
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <TextField
                select
                label="Country Code"
                name="clinicCountryCode"
                value={clinicDetails.clinicCountryCode}
                onChange={handleClinicChange}
                fullWidth
                error={!!errors.clinicCountryCode}
                helperText={errors.clinicCountryCode}
              >
                {allCountries.map((country) => (
                  <MenuItem
                    key={country.dialCode + country.iso2}
                    value={`+${country.dialCode}`}
                  >
                    {country.name} (+{country.dialCode})
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                label="Mobile"
                name="clinicMobile"
                value={clinicDetails.clinicMobile}
                onChange={handleClinicChange}
                fullWidth
                error={!!errors.clinicMobile}
                helperText={errors.clinicMobile}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Address"
                name="address"
                value={clinicDetails.address}
                onChange={handleClinicChange}
                fullWidth
                error={!!errors.address}
                helperText={errors.address}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="City"
                name="city"
                value={clinicDetails.city}
                onChange={handleClinicChange}
                error={!!errors.city}
                helperText={errors.city}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="State"
                name="state"
                value={clinicDetails.state}
                onChange={handleClinicChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Country"
                name="country"
                value={clinicDetails.country}
                onChange={handleClinicChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Map Link"
                name="mapLink"
                value={clinicDetails.mapLink}
                onChange={handleClinicChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                name="email"
                value={clinicDetails.email}
                onChange={handleClinicChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Website"
                name="website"
                value={clinicDetails.website}
                onChange={handleClinicChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ marginBottom: 2 }}>
          <Grid>
            <Typography variant="h6" gutterBottom>
              Clinic Logo
            </Typography>

            <Grid item xs={12} sm={6}>
              <input
                accept="image/*"
                type="file"
                onChange={handleImageUpload} // Add your image upload handler here
                style={{ display: "block", marginTop: "16px" }}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ marginBottom: 2 }}>
          <Typography variant="h6" gutterBottom>
            Air Details
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Air Name"
                name="kioskName"
                value={kioskDetails.kioskName}
                onChange={handleKioskChange}
                fullWidth
                error={!!errors.kioskName}
                helperText={errors.kioskName}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Location"
                name="kioskLocation"
                value={kioskDetails.kioskLocation}
                onChange={handleKioskChange}
                fullWidth
                error={!!errors.kioskLocation}
                helperText={errors.kioskLocation}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <TextField
                label="DW ID"
                name="DWId"
                value={kioskDetails.DWId}
                onChange={handleKioskChange}
                fullWidth
                // error={!!errors.kioskCode}
                // helperText={errors.kioskCode}
              />
            </Grid> */}
          </Grid>
        </Box>

        <CustomButton
          text="  Generate Credentials"
          width="265px"
          onClick={handleCredSubmit}
        />
        {/* Conditionally render username and password fields */}
        {showCredentials && (
          <Box sx={{ marginTop: 3 }}>
            <Typography variant="h6" gutterBottom>
              Login Credentials
            </Typography>
            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Username"
                  name="username"
                  value={doctorDetails.username}
                  fullWidth
                  error={!!errors.username}
                  helperText={errors.username}
                  onChange={handleDoctorChange}
                  //  InputProps={{
                  //    readOnly: true, // Make the field non-editable
                  //  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Password"
                  name="password"
                  value={doctorDetails.password}
                  type="password"
                  fullWidth
                  error={!!errors.password}
                  helperText={errors.password}
                  onChange={handleDoctorChange}
                  //  InputProps={{
                  //    readOnly: true, // Make the field non-editable
                  //  }}
                />
              </Grid>
            </Grid>

            <CustomButton text=" Submit" onClick={HandleSubmit} width="150px" />
          </Box>
        )}

        {Loading && <Loader />}
      </Paper>
    </Box>
  );
};

export default AddDoctor;
